module.exports = __webpack_public_path__ + "static/media/img6.007c2f12.png";